"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["Key"] = "key";
    ContentType["Translated"] = "translated";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
//# sourceMappingURL=db-types.js.map